<script>
export default {
  components: {},
  props: {
    cargoTypeId: {
      type: [String, Number],
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    modeType: {
      type: String,
      default: 'byCargoTypeId',
      validator: function(value) {
        return ['byCargoTypeIdMode', 'byDefCargoTypeIdMode', 'allDataMode'].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      groupOptions: [],
      defCargoTypeId: null
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    // 监听cargoTypeId变化，当有值时加载options
    cargoTypeId: {
      handler(newVal, oldVal) {
        // console.log('watch', newVal, ',', oldVal)
        if (!newVal && !oldVal) {
          // console.log('默认渲染')
          this.options = [];
          this.groupOptions = [];
        } else if (newVal && !oldVal) {
          // console.log('选中了值')
        } else if (!newVal && oldVal) {
          // console.log('取消了值')
        } else {
          // console.log('值变化了')
          this.options = [];
          this.groupOptions = [];
          this.selectedValue = null
        }
        this.initOptions();
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    async initOptions() {
      let cargoTypeIdParam = null;
      if(this.modeType === 'byCargoTypeIdMode'){
        if(!this.cargoTypeId){
          return;
        }
        cargoTypeIdParam = this.cargoTypeId;
      }else if(this.modeType === 'byDefCargoTypeIdMode'){
        //默认值
        await this.getDefContainerCargoTypeId();
        cargoTypeIdParam = this.defCargoTypeId
      }else if(this.modeType === 'allDataMode'){
        //全部数据
      }
      this.$store.dispatch('bu_cargoSpec/fetchOptions', {
        cargoTypeId: cargoTypeIdParam,
      }).then(res => {
        this.options = res.data;
        this.doGroupHandle()
      }).finally(() => {
        this.loading = false;
      });
    },
    doGroupHandle() {
      const _tmpGroupList = []
      this.options.forEach(item => {
        const groupField = item.groupName || '未知'
        const _group = _tmpGroupList.find(group => group.label === groupField)
        if (_group) {
          _group.children.push(item)
          return
        }
        _tmpGroupList.push({
          label: groupField,
          sort: item.groupId || 99,
          children: [item]
        })
      })
      const sortField = 'groupId'
      this.groupOptions = _tmpGroupList.sort((a, b) => a[sortField] - b[sortField])
    },
    onChange(val) {
      console.log('val')
      this.$emit('change', this.options.find(item => item.value === val))
    },
    //获取默认的cargoTypeId
    async getDefContainerCargoTypeId() {
      const dictInfo = await this.$store.dispatch('bu_dict/fetchOptions', {
        dictKey: 'defaultValue',
        dictLabel: 'container_cargo_type_id'
      })
      this.defCargoTypeId = parseInt(dictInfo.data.dictValue)
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    filterable
    clearable
    @change="onChange"
    style="width: 100%;"
  >
    <el-option-group
      v-for="group in groupOptions"
      :key="group.label"
      :label="group.label">
      <el-option
        v-for="item in group.children"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-option-group>
  </el-select>
</template>

<style lang="scss" scoped></style>
